module.exports = __webpack_public_path__ + "img/ico_utils_logout.c1f59e81.svg";